import { ABU } from "@client";
import { css } from "@emotion/css";
import React from "react";

export function Background({ src = `${ABU}img/bg.png` }: { src?: string }) {
  return (
    <img
      src={src}
      className={css`
        position: fixed;
        z-index: -10;
        min-width: 100vw;
        min-height: 100vh;
        filter: blur(1rem) grayscale(70%) brightness(70%);
      `}
      alt="bg"
    />
  );
}
